import styled from 'styled-components';

export const ProgressContainer = styled.div`
  display: flex;
  border-radius: 12px;
  background-color: grey;
  margin: 0;
  height: 24px;
  width: 100%;
  overflow: hidden;
`;

type StyledProgressbarProps = {
  width: number;
  color: string;
  minWidth: number;
};

export const ProgressbarPart = styled.div<StyledProgressbarProps>`
  display: inline-block;
  position: relative;
  background-color: ${({ color }) => color};
  margin: 0;
  width: ${({ width }) => width}%;
  min-width: ${({ minWidth }) => minWidth}px;
  height: 100%;
`;

export const ProgressbarPartContent = styled.div`
  color: ${({ theme }) => theme.colors.grey2};
  text-align: center;
`;
